import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import useGetIncidenceTaskDocuments from 'modules/bookkeepers/hooks/useGetIncidenceTaskDocuments'
import { useCurrentIncidence } from 'modules/bookkeepers/lib/CurrentIncidenceContext'
import { useTaskTypes } from 'modules/bookkeepers/lib/TaskTypesContext'
import { trackIncidenceCompleteTask } from 'modules/bookkeepers/lib/amplitudeData'
import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import TabsSelector from 'modules/payroll_bundle/components/TabsSelector'
import { useInhousePayroll } from 'modules/payroll_bundle/hooks/useInhousePayroll'

import IncidenceTasks from './_IncidenceTasks'

const IncidenceTasksTab = () => {
  const isBookkeeperView = useBookkeeperView()
  const incidence = useCurrentIncidence()
  const incidenceId = incidence?.id
  const taskTypes = useTaskTypes()
  const { hasInhousePayroll } = useInhousePayroll()
  const { refetch: refetchTaskDocuments, taskDocuments } = useGetIncidenceTaskDocuments({
    incidenceId,
  })

  const trackTaskComplete = (id: number, status: boolean) => {
    if (!status) return

    const taskType = taskTypes.find({ id })

    if (!taskType) return
    trackIncidenceCompleteTask(
      incidence,
      taskType.attributes.title,
      isBookkeeperView,
      hasInhousePayroll
    )
  }

  return (
    <>
      <TabsSelector selectedTab="tasks" incidenceId={incidenceId} isBookkeeper={isBookkeeperView} />
      <Box overflowY="hidden">
        <Box padding="s24" overflowY="auto" gap="s24">
          <IncidenceTasks
            taskTypes={taskTypes}
            taskDocuments={taskDocuments}
            incidenceId={incidenceId}
            trackTaskComplete={trackTaskComplete}
            refetchTaskDocuments={refetchTaskDocuments}
          />
        </Box>
      </Box>
    </>
  )
}

export default observer(IncidenceTasksTab)
